<!-- eslint-disable vue/no-v-html -->
<template>
  <div
    id="app"
    class="app"
  >
    <template v-if="isBrowserSupport && isWebGlSupport">
      <keep-alive :exclude="['login']">
        <router-view />
      </keep-alive>
    </template>
    <template v-else>
      <div class="full-center error-wrapper">
        <div v-if="!isBrowserSupport">
          <figure class="error-wrapper-container">
            <img
              :src="noSupportedImage"
              alt="browser no support"
            >
            <div v-html="$t('browserNoSupport')" />
          </figure>
        </div>
        <div v-else-if="!isWebGlSupport">
          <figure class="error-wrapper-container">
            <img
              :src="noSupportedImage"
              alt="webgl no support"
            >
            <div v-html="$t('webGlNoSupport')" />
          </figure>
        </div>
      </div>
    </template>
    <portal-target
      name="modal"
      multiple
    />
    <cookie-banner />
  </div>
</template>

<script>
import * as i18nHelper from './i18n/i18n-helper'
import CookieBanner from '../src/components/CookieBanner.vue'
export default {
  name: 'App',
  components: {
    CookieBanner
  },
  data () {
    return {
      isBrowserSupport: false,
      isWebGlSupport: false,
      noSupportedImage: require('./assets/images/error.png')
    }
  },
  beforeMount () {
    // Set Language
    const lang = i18nHelper.getBrowserLang()
    const locale = i18nHelper.getLocale(lang)
    this.$i18n.locale = locale
    this.$moment.locale(locale)

    // Fix the ontouch* APIs default to disabled on desktop issue.
    // https://www.chromestatus.com/feature/4764225348042752
    navigator.pointerEnabled = navigator.maxTouchPoints > 0 // Edge 17 touch support workaround
    document.documentElement.ontouchstart = navigator.maxTouchPoints > 0 // Chrome 70 touch support workaround
  },

  mounted () {
    const vh = window.innerHeight * 0.01
    document.documentElement.style.setProperty('--vh', `${vh}px`)
    const isIE10 = Number(document.documentMode) === 10
    if (!isIE10) {
      this.isBrowserSupport = true
    }

    const canvas = document.createElement('canvas')
    // Get WebGLRenderingContext from canvas element.
    const gl = canvas.getContext('webgl') || canvas.getContext('experimental-webgl')
    // Report the result.
    if (gl && gl instanceof WebGLRenderingContext) { // eslint-disable-line
      this.isWebGlSupport = true
    }
  }
}
</script>

<style lang="stylus" rel="stylesheet/stylus">
@import '~css/common/main'

.app {
  display: flex
  flex-direction: column
  height: 100%
}

.error-wrapper {
  background-color: #f1f8fc
  pointer-events: auto

  .error-wrapper-container {
    @extend .flex-center-column
    text-align: center

    img {
      margin-bottom: 20px
    }

    &, p, h3 {
      color: $black
      text-shadow: none
    }

    a {
      color: $pink-color
      text-decoration: none
      display: inline-block
      padding: 0 3px
      text-shadow: none

      &:hover {
        text-decoration: underline
      }
    }

    h3 {
      font-size: 18px
      letter-spacing: -.4px
    }

    p, a {
      font-size: 14px
      letter-spacing: -.3px
    }

    h3, p, a {
      margin-top: 7px
    }

    h3 {
      font-size: 18px
      letter-spacing: -.4px
    }

    p, a {
      font-size: 14px
      letter-spacing: -.3px
    }

    h3, p, a {
      margin-top: 7px
    }
  }
}
</style>
